<div class="page">
  <h1 class="title">{{ "general.kits" | translate }}</h1>
  <div fxLayout="column">
    <form [formGroup]="kitForm" #form="ngForm" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start start" fxFlex="100">
      <div fxLayout="column" fxLayoutAlign="start center">
        <mat-card class="image-upload">
          <div class="image-container">
            @if(editKit.pathImage) {
              <ng-container>
                <img [src]="editKit.pathImage" alt="{{ 'kit.image-alt' | translate }}" class="preview-image" />
              </ng-container>
            } @else {
              <ng-container>
                <mat-icon class="photo_camera">photo_camera</mat-icon>
              </ng-container>
            }
          </div>
          <label class="upload-button">
            <input #fileInput type="file" (change)="saveImage($event)" accept="image/*" hidden />
            <button mat-flat-button color="primary" (click)="triggerFileInput()">
              <mat-icon style="font-size: 13pt;">upload</mat-icon>
              <span style="font-size: 8pt;">{{ 'button.upload-image' | translate }}</span>
            </button>
          </label>
        </mat-card>
        <small class="upload-info">{{ 'button.max-size-message-5mb' | translate }}</small>
      </div>

      <div fxLayout="column" fxFlex="85">
        <div fxLayout="row" fxLayoutGap="16px">
          <mat-form-field fxFlex="100" appearance="outline">
            <mat-label>{{ 'general.kitDescription' | translate }}</mat-label>
            <input formControlName="description" name="description" matInput />
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
          <mat-form-field fxFlex="42" appearance="outline">
            <mat-label>{{ 'general.item' | translate }}</mat-label>
            <input
              type="text"
              matInput
              [formControl]="itemControl"
              [matAutocomplete]="auto"
              (focus)="openAutocompletePanel()"
            />
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete
              #auto="matAutocomplete"
              (optionSelected)="onItemSelected($event.option.value)"
              [displayWith]="displayItem"
            >
              <mat-option *ngFor="let option of filteredItems" [value]="option">
                #{{ option.partNumber }} - {{ option.description }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>

          <button
            mat-flat-button
            color="primary"
            class="add-button mg-b-22"
            [disabled]="!itemControl.valid"
            (click)="addItem()"
          >
            {{ 'button.add' | translate }}
          </button>
        </div>
      </div>
    </form>

    <div class="items-container">
      <table mat-table [dataSource]="dataSource">
        @for (column of displayedColumns; track column) {
          @if (column === 'codItem') {
            <ng-container [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header" style="width: 10%;">
                {{ 'general.codItem' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{ item.id }} </td>
            </ng-container>
          }
          @if (column === 'partNumber') {
            <ng-container [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header" style="width: 10%;">
                {{ 'general.partNumber' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{ item.partNumber }} </td>
            </ng-container>
          }
          @if (column === 'item') {
            <ng-container [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header" style="width: 30%;">
                {{ 'general.item' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{ item.description }} </td>
            </ng-container>
          }
          @if (column === 'category') {
            <ng-container [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header" style="width: 20%;">
                {{ 'general.category' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{ item.category.category }} </td>
            </ng-container>
          }
          @if (column === 'manufacturer') {
            <ng-container [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header" style="width: 20%;">
                {{ 'general.manufacturer' | translate }}
              </th>
              <td mat-cell *matCellDef="let item"> {{ item.manufacturer }} </td>
            </ng-container>
          }
          @if (column === 'action') {
            <ng-container [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef class="table-header action" style="width: 10%;">
                {{ 'general.action' | translate }}
              </th>
              <td mat-cell *matCellDef="let item" class="action">
                <button mat-icon-button class="custom-red" (click)="deleteItem(item)">
                  <mat-icon matTooltip="{{ 'button.delete-tooltip' | translate }}" style="color: #B41E2A;">
                    delete
                  </mat-icon>
                </button>
                <button mat-icon-button (click)="updateItem(item.id)">
                  <mat-icon matTooltip="{{ 'button.edit-tooltip' | translate }}">
                    edit
                  </mat-icon>
                </button>
              </td>
            </ng-container>
          }
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <mat-paginator
      [length]="pageable.length"
      [pageSize]="pageable.pageSize"
      (page)="pageChange($event)"
      [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>

<app-breadcrumbs [breadcrumbsData]="breadcrumbsData"></app-breadcrumbs>
